import { render, staticRenderFns } from "./ebay.vue?vue&type=template&id=4836023f&scoped=true"
import script from "./ebay.vue?vue&type=script&lang=js"
export * from "./ebay.vue?vue&type=script&lang=js"
import style0 from "./ebay.vue?vue&type=style&index=0&id=4836023f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4836023f",
  null
  
)

export default component.exports